module.exports = __webpack_public_path__ + "media/images/sandbox/product_header_pads-7c2dfea9b85b414f53f435f9b04de9fc.jpg";